var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditedSection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21 22H3C2.59 22 2.25 21.66 2.25 21.25C2.25 20.84 2.59 20.5 3 20.5H21C21.41 20.5 21.75 20.84 21.75 21.25C21.75 21.66 21.41 22 21 22Z",
    fill: "#A39ED2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.02 3.48C17.08 1.54 15.18 1.49 13.19 3.48L11.98 4.69C11.88 4.79 11.84 4.95 11.88 5.09C12.64 7.74 14.76 9.86 17.41 10.62C17.45 10.63 17.49 10.64 17.53 10.64C17.64 10.64 17.74 10.6 17.82 10.52L19.02 9.31C20.01 8.33 20.49 7.38 20.49 6.42C20.5 5.43 20.02 4.47 19.02 3.48Z",
    fill: "#A39ED2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.61 11.53C15.32 11.39 15.04 11.25 14.77 11.09C14.55 10.96 14.34 10.82 14.13 10.67C13.96 10.56 13.76 10.4 13.57 10.24C13.55 10.23 13.48 10.17 13.4 10.09C13.07 9.81 12.7 9.45 12.37 9.05C12.34 9.03 12.29 8.96 12.22 8.87C12.12 8.75 11.95 8.55 11.8 8.32C11.68 8.17 11.54 7.95 11.41 7.73C11.25 7.46 11.11 7.19 10.97 6.91C10.83 6.61 10.72 6.32 10.62 6.05L4.34001 12.33C4.21001 12.46 4.09001 12.71 4.06001 12.88L3.52001 16.71C3.42001 17.39 3.61001 18.03 4.03001 18.46C4.39001 18.81 4.89001 19 5.43001 19C5.55001 19 5.67001 18.99 5.79001 18.97L9.63001 18.43C9.81001 18.4 10.06 18.28 10.18 18.15L16.46 11.87C16.18 11.77 15.91 11.66 15.61 11.53Z",
    fill: "#A39ED2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditedSection);
export default __webpack_public_path__ + "static/media/edited-section.b907a81e57b44e4609fc899df7e7a214.svg";
export { ForwardRef as ReactComponent };